export const identity = (value) => value;
export const always = () => true;
export const noop = () => {};
